(function() {
'use strict';

angular.module('TR')
    .directive('newsletterBanner', (currentUser, cookieService, $timeout) => ({
        restrict: 'E',
        replace: true,
        transclude: true,
        templateUrl: 'partials/home/directivetemplate?type=newsletterbanner',
        controllerAs: 'nb',
        controller($scope, $rootScope) {
            const key = 'trpNewsletterClose';
            const monthMs = 2592e6; // 30 days
            const tempTTL = monthMs * 3;
            const permTTL = monthMs * 120;
            const user = currentUser.get();
            const isSignedIn = user && user.HardSignedIn;

            this.if = false; // DOM inclusion
            this.hide = false; // CSS transition

            if (!isSignedIn) {
                // Get persisted timestamp (async)
                localforage.getItem(key, (err, value) => {
                    let hideTs = value * 1; // Ensure is a number
                    let cookies = cookieService.get('CookiesAccepted') || false;

                    if (hideTs && (Date.now() > hideTs)) {
                        localforage.removeItem(key);
                        hideTs = null;
                    }
                    this.hide = !cookies; // Hide if cookies never accepted
                    this.if = !hideTs;
                });
            }

            this.close = (ttl = tempTTL) => {
                localforage.setItem(key, Date.now() + ttl);
                this.hide = true;
                $timeout(() => this.if = false, 1000);
            };

            $rootScope.$on('cookiesAccepted', () => {
                this.hide = false;
            });

            $scope.$on('newsletterSignUp', () => {
                // Display success message before hiding
                $timeout(() => {
                    this.close(permTTL);
                }, 1400);
            });
        }
    }));
})();
